import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=a17b78b4&scoped=true"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"
import style0 from "./Admins.vue?vue&type=style&index=0&id=a17b78b4&prod&lang=scss&scoped=true"
import style1 from "./Admins.vue?vue&type=style&index=1&id=a17b78b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17b78b4",
  null
  
)

export default component.exports